import { useApi } from 'services';

export const useListPersonProduct = () => useApi(`/query`, 'POST', {}, { id: "fitGetProductPerson", params: {} });